export default {
  sorry: 'Beklager',
  sorryClass: 'Vi beklager, men vi kunne ikke finde ',
  weFound: 'vi fandt ',
  noResults: 'ingen resultater',
  fares: '-afgange',
  theseDates: ' på disse datoer.',
  matchingSearch: ', som svarer til din søgning',
}
